import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Calendar, Search, ArrowRightLeft, Car } from "lucide-react";

export default function SearchBar() {
  const nav = useNavigate();
  const [f, setF] = useState({
    pickup_location: "",
    return_location: "",
    pickup_datetime: "",
    return_datetime: "",
    category: "",
  });
  const [differentReturn, setDifferentReturn] = useState(false);

  const onSearch = () => {
    const q = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
    nav(`/fleet?${q}`);
  };

  return (
    <div className="relative z-30 -mt-10 sm:-mt-16 max-w-6xl mx-auto bg-[#171717]/95 border border-[#2E2E2E] rounded-2xl sm:rounded-3xl shadow-2xl shadow-black/60 backdrop-blur-xl">
      {/* Header strip */}
      <div className="flex items-center justify-between px-5 sm:px-7 pt-5 pb-3 border-b border-[#2E2E2E]">
        <div className="flex items-center gap-2">
          <Car className="w-4 h-4 text-[#D9A62E]" />
          <span className="text-xs font-mono-piki uppercase tracking-widest text-[#D9A62E] font-semibold">Find your ride</span>
        </div>
        <label className="flex items-center gap-2 text-[11px] text-[#A3A3A3] cursor-pointer select-none">
          <input
            type="checkbox"
            checked={differentReturn}
            onChange={(e) => {
              setDifferentReturn(e.target.checked);
              if (!e.target.checked) setF((s) => ({ ...s, return_location: "" }));
            }}
            className="accent-[#D9A62E]"
            data-testid="search-bar-different-return-toggle"
          />
          <ArrowRightLeft className="w-3 h-3" /> Return to a different location
        </label>
      </div>

      {/* Fields */}
      <div className="p-4 sm:p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 items-end">
        <Field
          className={differentReturn ? "lg:col-span-3" : "lg:col-span-4"}
          label="Pick-up Location"
          icon={<MapPin className="w-3 h-3 text-[#D9A62E]" />}
        >
          <input
            data-testid="search-bar-pickup-location-input"
            className="piki-input text-sm"
            placeholder="Enter pick-up location"
            value={f.pickup_location}
            onChange={(e) => setF({ ...f, pickup_location: e.target.value })}
          />
        </Field>

        {differentReturn && (
          <Field className="lg:col-span-3" label="Return Location" icon={<MapPin className="w-3 h-3 text-[#D9A62E]" />}>
            <input
              data-testid="search-bar-return-location-input"
              className="piki-input text-sm"
              placeholder="Return address / hub…"
              value={f.return_location}
              onChange={(e) => setF({ ...f, return_location: e.target.value })}
            />
          </Field>
        )}

        <Field className="lg:col-span-2" label="Pick-up" icon={<Calendar className="w-3 h-3 text-[#D9A62E]" />}>
          <input
            type="datetime-local"
            data-testid="search-bar-pickup-date-input"
            className="piki-input text-sm"
            value={f.pickup_datetime}
            onChange={(e) => setF({ ...f, pickup_datetime: e.target.value })}
          />
        </Field>

        <Field className="lg:col-span-2" label="Return" icon={<Calendar className="w-3 h-3 text-[#D9A62E]" />}>
          <input
            type="datetime-local"
            data-testid="search-bar-return-date-input"
            className="piki-input text-sm"
            value={f.return_datetime}
            onChange={(e) => setF({ ...f, return_datetime: e.target.value })}
          />
        </Field>

        <Field className="lg:col-span-2" label="Vehicle Category">
          <select
            data-testid="search-bar-category-select"
            className="piki-input text-sm"
            value={f.category}
            onChange={(e) => setF({ ...f, category: e.target.value })}
          >
            <option value="">All Vehicles</option>
            <option value="Compact">Compact</option>
            <option value="Sedan">Sedan</option>
            <option value="SUV">SUV</option>
            <option value="People Mover">People Mover</option>
          </select>
        </Field>

        <button
          onClick={onSearch}
          data-testid="search-bar-submit-btn"
          className={`piki-gold-btn flex items-center justify-center gap-2 py-3.5 sm:col-span-2 ${differentReturn ? "lg:col-span-12" : "lg:col-span-2"}`}
        >
          <Search className="w-4 h-4" /> Search Cars
        </button>
      </div>
    </div>
  );
}

function Field({ label, icon, children, className = "" }) {
  return (
    <div className={className}>
      <label className="text-[10px] uppercase tracking-wider text-[#A3A3A3] font-semibold flex items-center gap-1.5 mb-1.5">
        {icon} {label}
      </label>
      {children}
    </div>
  );
}
